import { useAuth } from "@/hooks/auth/useAuth";
import { Navigate, Outlet } from "react-router-dom";

const UnauthenticatedLayout = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <img src="/text-logo.svg" alt="Logo" className="w-2/3 animate-pulse" />
      </div>
    );
  }

  if (user) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="h-screen bg-background">
      <Outlet />
    </div>
  );
};

export default UnauthenticatedLayout;
